// Autogenerated file
export const syncSystemBehaviorsEnum = {
    Read: "Read",
    ReadConfirmation: "ReadConfirmation",
};
export const syncSystemBehaviors = [
    { label: "Только чтение", value: "Read" },
    { label: "Чтение с подтверждением", value: "ReadConfirmation" },
];
